module.exports = __webpack_public_path__ + "static/integration/d2l/img/ally-icon-indicator-high.4fccb0f18334b56672d171b4dac3f1c4.svg";